import styled from 'styled-components';

export const HomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 100px;
  align-items: center;
  color:white;
`;

export const Title = styled.div`
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: bold;
  letter-spacing: 4px;
`;

export const SubTitle = styled.div`
  font-size: 1.2rem;
`;

export const ModelImg = styled.img`
    width: 40%;
    max-width: 400px;
    margin-bottom: 1em;
    margin-top: -2em;
`;
